import { h } from 'preact';
import { FormAnnotation } from './';
import { expandable } from 'rendering/behaviors/expandable';
import { ControlBar } from 'rendering/components/adjacent_control_bar';

@expandable
export class AdjacentFormAnnotation extends FormAnnotation {
    render() {
        const rendered = super.render(),
            { expanded } = this.props;

        // ensure element takes up entire space
        rendered.props.style.left = 'auto';
        rendered.props.style.right = 'auto';
        rendered.props.style.top = 'auto';
        rendered.props.style.bottom = 'auto';
        rendered.props.style.width = '100%';
        rendered.props.style.height = '100%';
        rendered.props.style.borderRadius = 0;

        rendered.props.children = [
            <ControlBar expanded={ expanded } onExpand={ this.onExpand } onCollapse={ this.onCollapse } styles={ this.controlBarStyles }/>
        ].concat(rendered.props.children);

        return rendered;
    }
}